import React, { useState, useEffect, Fragment, useRef } from "react";
import Container from 'react-bootstrap/Container';
import axios from 'axios';
import AuthService from '../../Auth/AuthService.js';
import { settings } from './../../Helpers/Settings.js';
import { ToastContainer, toast } from "react-toastify";
import { useDownloadExcel } from 'react-export-table-to-excel';
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2'
import PageTitle from "../../Components/PageTitle.js";
import { decodeToken, isExpired } from "react-jwt";

const MasrafTuru = () => {
    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [yetkiGor, setYetkiGor] = useState(null);
    const [yetkiEkle, setYetkiEkle] = useState(false);
    const [yetkiDegistir, setYetkiDegistir] = useState(false);
    const [yetkiSil, setYetkiSil] = useState(false);

    const [currentId, setCurrentId] = useState(0);
    const [masrafTuruInsert, setMasrafTuruInsert] = useState('');
    const [konuInsert, setKonuInsert] = useState('');
    const [turInsert, setTurInsert] = useState('');
    const [cariInsert, setCariInsert] = useState('');
    const [parcaInsert, setParcaInsert] = useState('');
    const [masrafTuruUpdate, setMasrafTuruUpdate] = useState('');
    const [konuUpdate, setKonuUpdate] = useState('');
    const [turUpdate, setTurUpdate] = useState('');
    const [cariUpdate, setCariUpdate] = useState('');
    const [parcaUpdate, setParcaUpdate] = useState('');

    const [data, setData] = useState(null);

    const tableRef = useRef(null);

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);
            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    useEffect(() => {
        getAcilisData();
    }, []);

    const getAcilisData = async () => {
        if (await tokenYenile() === false) {
            return;
        }

        try {
            let tempYetkiGor = await AuthService.getYetkiKontrolByYetki("Tanımlamalar - Masraf Türleri - Gör");

            setYetkiGor(tempYetkiGor);

            if (tempYetkiGor === true) {
                setYetkiEkle(await AuthService.getYetkiKontrolByYetki("Tanımlamalar - Masraf Türleri - Ekle"));
                setYetkiDegistir(await AuthService.getYetkiKontrolByYetki("Tanımlamalar - Masraf Türleri - Değiştir"));
                setYetkiSil(await AuthService.getYetkiKontrolByYetki("Tanımlamalar - Masraf Türleri - Sil"));

                await getData();
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getData = async () => {
        try {
            const res = await axios.get(settings.ApiUrl + 'MasrafTuru/GetMasrafTuruList', { headers: AuthService.getHeaders() });

            if (res) {
                setData(res.data.value);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const Degistir = async (id) => {
        if (await tokenYenile() === false) {
            return;
        }

        try {
            const result = await axios.get(settings.ApiUrl + 'MasrafTuru/GetMasrafTuru/' + id, { headers: AuthService.getHeaders() });

            if (result) {
                setCurrentId(id);
                setMasrafTuruUpdate(result.data.value.masrafTuru);
                setKonuUpdate(result.data.value.konu);
                setTurUpdate(result.data.value.tur);
                setCariUpdate(result.data.value.cari);
                setParcaUpdate(result.data.value.parca);
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const Sil = async (id) => {
        if (await tokenYenile() === false) {
            return;
        }

        Swal.fire({
            title: "Uyarı",
            text: "Kayıt silinecek, emin misiniz?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sil",
            cancelButtonText: "Vazgeç"
        }).then(async (resultSwal) => {
            if (resultSwal.isConfirmed) {
                try {
                    const resultGet = await axios.get(settings.ApiUrl + 'MasrafTuru/GetMasrafTuru/' + id, { headers: AuthService.getHeaders() });

                    if (resultGet) {
                        const resultDelete = await axios.post(settings.ApiUrl + 'MasrafTuru/DeleteMasrafTuru', [resultGet.data.value], { headers: AuthService.getHeaders() });

                        if (resultDelete) {
                            if (resultDelete.data.success === true) {
                                await getData();
                                toast.success("Silindi");
                            } else {
                                toast.error(resultDelete.data.message);
                            }
                        }
                    }
                } catch (error) {
                    toast.error(error);
                }
            }
        });
    }

    const Kaydet = async (kayitModu) => {
        if (await tokenYenile() === false) {
            return;
        }
        
        let masrafTuru = kayitModu === "insert" ? masrafTuruInsert : masrafTuruUpdate;
        let konu = kayitModu === "insert" ? konuInsert : konuUpdate;
        let tur = kayitModu === "insert" ? turInsert : turUpdate;
        let cari = kayitModu === "insert" ? cariInsert : cariUpdate;
        let parca = kayitModu === "insert" ? parcaInsert : parcaUpdate;

        if (masrafTuru === "" || konu === "" || tur === "" || cari === "" || parca === "") {
            Swal.fire({ title: "Hata", text: "Lütfen zorunlu alanları doldurunuz", icon: "error" });
        } else {
            try {
                const data = JSON.stringify({
                    "id": kayitModu === "insert" ? 0 : currentId,
                    "masrafTuru": masrafTuru,
                    "konu": konu,
                    "tur": tur,
                    "cari": cari,
                    "parca": parca
                });

                const result = await axios.post(settings.ApiUrl + 'MasrafTuru/InsertOrUpdateMasrafTuru/', data, { headers: AuthService.getHeaders() });

                if (result) {
                    if (result.data.success) {
                        setCurrentId(0);

                        if (kayitModu === "insert") {
                            setMasrafTuruInsert("");
                            setKonuInsert("");
                            setTurInsert("");
                            setCariInsert("");
                            setParcaInsert("");
                        }

                        await getData();

                        toast.success("Kaydedildi");
                    } else {
                        toast.error("Hata oluştu: " + result.data.message);
                    }
                }
            } catch (error) {
                toast.error("Hata oluştu:" + error);
            }
        }
    }

    const Vazgec = async () => {
        setCurrentId(0);
    }

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: "MasrafTurleriListesi",
        sheet: "MasrafTurleriListesi"
    })

    return (
        <Fragment>
            <Container>
                <ToastContainer position="bottom-right">
                </ToastContainer>
            </Container>

            <PageTitle></PageTitle>

            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    yetkiGor !== null ?
                        yetkiGor === false ?
                            <div className="alert alert-danger">
                                Bu sayfaya erişim yetkiniz bulunmamaktadır
                            </div>
                            :
                            <div className="card info-card mb-2">
                                <div className="table-responsive">
                                    <table ref={tableRef} className="table table-bordered table-hover table-sm mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{textAlign:"center"}}>Masraf Türü</th>
                                                <th style={{textAlign:"center"}}>Konu</th>
                                                <th style={{textAlign:"center"}}>Tür</th>
                                                <th style={{textAlign:"center"}}>Cari</th>
                                                <th style={{textAlign:"center"}}>Parça</th>
                                                <th style={{textAlign:"center"}}>
                                                    <button className="btn btn-sm btn-icon text-success" onClick={onDownload}><i className="bi bi-file-earmark-excel"></i></button>
                                                </th>
                                            </tr>
                                            <tr>
                                                <th style={{textAlign:"center"}}>
                                                    <input type="text" className="form-control form-control-sm" value={masrafTuruInsert} onChange={(e) => setMasrafTuruInsert(e.target.value)}></input>
                                                </th>
                                                <th style={{textAlign:"center"}}>
                                                    <input type="text" className="form-control form-control-sm" value={konuInsert} onChange={(e) => setKonuInsert(e.target.value)}></input>
                                                </th>
                                                <th style={{textAlign:"center"}}>
                                                    <input type="text" className="form-control form-control-sm" value={turInsert} onChange={(e) => setTurInsert(e.target.value)}></input>
                                                </th>
                                                <th style={{textAlign:"center"}}>
                                                    <input type="number" className="form-control form-control-sm" value={cariInsert} onChange={(e) => setCariInsert(e.target.value)}></input>
                                                </th>
                                                <th style={{textAlign:"center"}}>
                                                    <input type="number" className="form-control form-control-sm" value={parcaInsert} onChange={(e) => setParcaInsert(e.target.value)}></input>
                                                </th>
                                                <th style={{textAlign:"center"}}>
                                                    { yetkiEkle === true ? <button className="btn btn-sm btn-icon text-success" onClick={() => Kaydet("insert")}><i className="bi bi-plus-circle"></i></button> : '' }
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                data && data.length > 0 ?
                                                    data.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td align="center">
                                                                    {
                                                                        currentId === item.id ?
                                                                            <input type="text" className="form-control form-control-sm" value={masrafTuruUpdate} onChange={(e) => setMasrafTuruUpdate(e.target.value)}></input>
                                                                            :
                                                                            item.masrafTuru
                                                                    }
                                                                </td>
                                                                <td align="center">
                                                                    {
                                                                        currentId === item.id ?
                                                                            <input type="text" className="form-control form-control-sm" value={konuUpdate} onChange={(e) => setKonuUpdate(e.target.value)}></input>
                                                                            :
                                                                            item.konu
                                                                    }
                                                                </td>
                                                                <td align="center">
                                                                    {
                                                                        currentId === item.id ?
                                                                            <input type="text" className="form-control form-control-sm" value={turUpdate} onChange={(e) => setTurUpdate(e.target.value)}></input>
                                                                            :
                                                                            item.tur
                                                                    }
                                                                </td>
                                                                <td align="center">
                                                                    {
                                                                        currentId === item.id ?
                                                                            <input type="text" className="form-control form-control-sm" value={cariUpdate} onChange={(e) => setCariUpdate(e.target.value)}></input>
                                                                            :
                                                                            item.cari
                                                                    }
                                                                </td>
                                                                <td align="center">
                                                                    {
                                                                        currentId === item.id ?
                                                                            <input type="text" className="form-control form-control-sm" value={parcaUpdate} onChange={(e) => setParcaUpdate(e.target.value)}></input>
                                                                            :
                                                                            item.parca
                                                                    }
                                                                </td>
                                                                <td align="center">
                                                                    {
                                                                        currentId === item.id ?
                                                                            <div className="btn-group">
                                                                                <button className="btn btn-sm btn-icon text-success" onClick={() => Kaydet("update")}><i className="bi bi-check-circle"></i></button>
                                                                                <button className="btn btn-sm btn-icon text-danger" onClick={() => Vazgec()}><i className="bi bi-x-circle"></i></button>
                                                                            </div>
                                                                            :
                                                                            <div className="btn-group">
                                                                                { yetkiDegistir === true ? <button className="btn btn-sm btn-icon text-info" onClick={() => Degistir(item.id)}><i className="bi bi-pencil"></i></button> : '' }
                                                                                { yetkiSil === true ? <button className="btn btn-sm btn-icon text-danger" onClick={() => Sil(item.id)}><i className="bi bi-trash3"></i></button> : '' }
                                                                            </div>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                    :
                                                    <tr>
                                                        <td align="center" colSpan="4" style={{height:"48px"}}>
                                                            Kayıt yok
                                                        </td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        :
                        ""
            }

        </Fragment>
    );
};

export default MasrafTuru;